import store from '@/plugins/store'

const UnLogged = function (to, from, next) {
  store.dispatch('auth/check')
    .finally(() => {
      if (!store.getters['auth/isUnLogged']) {
        next('/error')
      }

      next()
    })
}

export default UnLogged
